import { NgModule } from '@angular/core';
import { CamelToTitlePipe } from './camel-to-title.pipe';
import { DateFormatPipe } from './date-format.pipe';
import { IntensityTextPipe } from './intensity-text.pipe';
import { ItemClassFixPipe } from './item-class-fix.pipe';
import { QualityTextPipe } from './quality-text.pipe';
import { QuestionLabelPipe } from './question-label.pipe';
import { SafePipe } from './safe.pipe';
import { StartCasePipe } from './start-case.pipe';
import { StressTextPipe } from './stress-text.pipe';
import { SymptomActionTextPipe } from './symptom-action-text.pipe';
import { SymptomActivityTextPipe } from './symptom-activity-text.pipe';
import { SymptomMedicationTextPipe } from './symptom-medication-text.pipe';
import { SymptomSeverityTextPipe } from './symptom-severity-text.pipe';
import { ThousandsCommaPipe } from './thousands-comma.pipe';


@NgModule({
  declarations: [
    ItemClassFixPipe,
    DateFormatPipe,
    IntensityTextPipe,
    StartCasePipe,
    StressTextPipe,
    SymptomActionTextPipe,
    SymptomMedicationTextPipe,
    SymptomSeverityTextPipe,
    ThousandsCommaPipe,
    QualityTextPipe,
    CamelToTitlePipe,
    SymptomActivityTextPipe,
    QuestionLabelPipe,
    SafePipe,
  ],
  imports: [],
  exports: [
    ItemClassFixPipe,
    DateFormatPipe,
    IntensityTextPipe,
    StartCasePipe,
    StressTextPipe,
    SymptomActionTextPipe,
    SymptomMedicationTextPipe,
    SymptomSeverityTextPipe,
    ThousandsCommaPipe,
    QualityTextPipe,
    CamelToTitlePipe,
    SymptomActivityTextPipe,
    QuestionLabelPipe,
    SafePipe,
  ]
})
export class PipesModule { }
